import { ReactNode } from "react";
import { useTenantPlan, FeatureKey } from "@/hooks/useTenantPlan";
import AccessDeniedPage from "@/pages/app/AccessDeniedPage";
import { Loader2 } from "lucide-react";

interface FeatureGateProps {
  featureKey: FeatureKey;
  fallback?: ReactNode;
  children: ReactNode;
}

export function FeatureGate({ featureKey, fallback, children }: FeatureGateProps) {
  const { hasFeature, isLoading } = useTenantPlan();

  if (isLoading) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!hasFeature(featureKey)) {
    return <>{fallback ?? <AccessDeniedPage featureName={featureKey} />}</>;
  }

  return <>{children}</>;
}
